export default "__VITE_ASSET__BdC_DTqE__"